import * as React from 'react'
//Freebie ErrorCard
export const ErrorCard = ({message}:{message:string}) => {
 return (<div className="freebie-state-card freebie-state-card--error">
    <p className="freebie-state-card__kicker">Något gick fel</p>
    <h2>Oj</h2>
    <p>{message}</p>
  </div>);
}
